import { parseUtcAssumedDate } from '../../../../../utils/formatUtils';

export const getNextPingLabel = (
    lastSeenAt: string | null,
    heartbeatIntervalMinutes?: number | null,
    nowMs = Date.now(),
): string | null => {
    const lastSeen = parseUtcAssumedDate(lastSeenAt);
    const intervalMinutes = heartbeatIntervalMinutes ?? 1;
    if (!lastSeen || !Number.isInteger(intervalMinutes) || intervalMinutes <= 0) return null;

    const remainingSeconds = Math.ceil(
        (lastSeen.getTime() + intervalMinutes * 60_000 - nowMs) / 1000,
    );

    if (remainingSeconds <= 0) return 'Overdue';
    if (remainingSeconds < 60) return `${remainingSeconds}s`;

    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
};
